import { render } from "./TreePage.vue?vue&type=template&id=1e6b745e&ts=true"
import script from "./TreePage.vue?vue&type=script&lang=ts"
export * from "./TreePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__